var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5V18.5C5.5 20.7091 7.29086 22.5 9.5 22.5H15.5C17.7091 22.5 19.5 20.7091 19.5 18.5V8.5M14.5 11.5V17.5M10.5 11.5L10.5 17.5M16.5 5.5L15.0937 3.3906C14.7228 2.8342 14.0983 2.5 13.4296 2.5H11.5704C10.9017 2.5 10.2772 2.8342 9.90627 3.3906L8.5 5.5M16.5 5.5H8.5M16.5 5.5H21.5M8.5 5.5H3.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash_white.9cb2078003e75889eff4f6e0310d7d78.svg";